import React, { useState, useRef, useEffect, useContext } from "react";
import { motion } from "framer-motion";
import useAIAudio from "../../aivoice/aivoice";
import PromotionModal from "../../../Components/popmodal";
import { UserContext } from "../../../context/UserContext";

const Preparationai = ({ handleMCQClick, handleFRQClick }) => {
    const { user } = useContext(UserContext);

    // 모달 & 목록 상태
    const [modalOpen, setModalOpen] = useState(false);
    const [showList, setShowList] = useState(false);

    // 툴팁 상태
    const [showTooltip, setShowTooltip] = useState(false);
    useEffect(() => {
        const interval = setInterval(() => {
            setShowTooltip(true);
            setTimeout(() => setShowTooltip(false), 2000);
        }, Math.random() * 3000 + 2000);

        return () => clearInterval(interval);
    }, []);

    // AI 버튼 클릭
    const showlist = () => {
        // 프리미엄 아닌 경우 모달 오픈
        if (user.premium === 0) {
            setModalOpen(true);
            return;
        }
        // 프리미엄이라면 목록 토글
        setShowList(!showList);
    };

    return (
        <div className="relative">
            <PromotionModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />

            {/* AI 버튼 */}
            <motion.div
                className="fixed bottom-[30px] right-[30px] flex items-center justify-center w-16 h-16 text-white font-bold text-lg rounded-full shadow-lg cursor-pointer"
                initial={{ scale: 1 }}
                animate={{
                    scale: [1, 1.1, 1],
                    background: [
                        "linear-gradient(45deg, #4a90e2, #8e44ad)",
                        "linear-gradient(45deg, #8e44ad, #4a90e2)",
                        "linear-gradient(45deg, #4a90e2, #8e44ad)",
                    ],
                }}
                transition={{
                    scale: {
                        duration: 2,
                        repeat: Infinity,
                        ease: "easeInOut",
                    },
                    background: {
                        duration: 3,
                        repeat: Infinity,
                        ease: "easeInOut",
                    },
                }}
                style={{
                    boxShadow: "0 0 15px 5px rgba(138, 43, 226, 0.7)",
                }}
                onClick={showlist}
            >
                AI
            </motion.div>

            {/* 말풍선 1 */}
            {showTooltip && !showList && (
                <motion.div
                    className="fixed bottom-[100px] right-[25px] bg-gray-800 text-white text-sm w-[100px] p-2 rounded-md shadow-md"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    transition={{ duration: 0.5 }}
                >
                    <div className="ml-[9px]">Click me!</div>
                </motion.div>
            )}

            {/* 말풍선 2 */}
            {showList && (
                <>
                    <motion.div
                        className="fixed bottom-[255px] right-[25px] bg-gray-800 text-white text-sm w-[400px] p-4 rounded-md shadow-md"
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        transition={{ duration: 0.5 }}
                    >
                        Hi, Let me pick question you need to practice with!
                    </motion.div>

                    <motion.div
                        className="fixed bottom-[200px] right-[25px] text-white text-sm w-[400px] p-4 rounded-md shadow-md cursor-pointer"
                        initial={{ scale: 1 }}
                        animate={{
                            scale: [1, 1.1, 1],
                            background: [
                                "linear-gradient(45deg, #4a90e2, #8e44ad)",
                                "linear-gradient(45deg, #8e44ad, #4a90e2)",
                                "linear-gradient(45deg, #4a90e2, #8e44ad)",
                            ],
                        }}
                        whileHover={{
                            scale: 1.1,
                            transition: { duration: 0.2, ease: "easeInOut" },
                        }}
                        exit={{ opacity: 0, y: 10 }}
                        transition={{ duration: 0.5 }}
                        style={{
                            cursor: 'url("path-to-your-cursor-image.png"), pointer',
                        }}
                        onClick={handleMCQClick}
                    >
                        ✨ English Questions
                    </motion.div>

                    <motion.div
                        className="fixed bottom-[145px] right-[25px] text-white text-sm w-[400px] p-4 rounded-md shadow-md cursor-pointer"
                        initial={{ scale: 1 }}
                        animate={{
                            scale: [1, 1.1, 1],
                            background: [
                                "linear-gradient(45deg, #4a90e2, #8e44ad)",
                                "linear-gradient(45deg, #8e44ad, #4a90e2)",
                                "linear-gradient(45deg, #4a90e2, #8e44ad)",
                            ],
                        }}
                        whileHover={{
                            scale: 1.1,
                            transition: { duration: 0.2, ease: "easeInOut" },
                        }}
                        exit={{ opacity: 0, y: 10 }}
                        transition={{ duration: 0.5 }}
                        style={{
                            cursor: 'url("path-to-your-cursor-image.png"), pointer',
                        }}
                        onClick={handleFRQClick}
                    >
                        ✨ Math Questions
                    </motion.div>
                </>
            )}
        </div>
    );
};

export default Preparationai;
